import React, { FunctionComponent, useCallback } from 'react'

import { Icon, IconColors } from '../Icon'
import { RateSizes } from './constants'
import styles from './style.module.scss'

interface RateItemProps {
  index: number
  value: number
  size: RateSizes
}

export const RateItem: FunctionComponent<RateItemProps> = ({ index, value, size = 'Small' }): JSX.Element => {
  const getColor = useCallback(
    (curr: number): IconColors => {
      return curr <= value ? 'Lemon Dark' : 'Gray80'
    },
    [value]
  )

  return (
    <li className={styles.item}>
      <div className={styles.itemFirst}>
        <Icon name='Star' title='rate-star' role='img' color={getColor(index - 0.5)} size={size} />
      </div>
      <div>
        <Icon name='Star' title='rate-star' role='img' color={getColor(index)} size={size} />
      </div>
    </li>
  )
}
